import React, { forwardRef, useMemo, useEffect, useState, useRef } from "react";
import useServiceStore from "store/serviceStore";
import { GRAINS, ARRAY, pixelPerInch } from "constants/appConstant";
import { HorizontalRuler, HospitalBed } from "components";
import Wrapper from "./headwall-components/wrapper";
import {
  alterImageUrl,
  calculateHeight,
  calculateWidth,
} from "config/calculations/calculation";

const Array = forwardRef((props, ref) => {
  const {
    values,
    ruler,
    handleDragStart,
    handleonDragOver,
    handleDrop,
    handleDragEnter,
    dragEntered,
    service,
    clickArrowLeft,
    clickArrowRight,
    clickArrowUp,
    clickArrowDown,
    showBedGraphic
  } = props;
  const wrapperRef = useRef(null);

  const [customEvent, setCustomEvent] = useState(null);
  const { serv, view_only, setService } = useServiceStore();
  const {
    // color,
    headwalls,
    ceiling_height,
    // background,
    model,
    accessory_rails,
  } = values;

  const [railInd, setRailInd] = useState(0);
  const [rowInd, setRowInd] = useState(0);

  const wallWidth = useMemo(() => {
    let totalWidth = 0;
    //added 10 inches extra to manage wall width
    if (headwalls.length >= 2) {
      headwalls.map((wall) => {
        totalWidth += Number(wall.width);
        return totalWidth;
      });
      return (totalWidth * 12) / pixelPerInch + 700;
    }
  }, [headwalls]);

  const rulerWidth = useMemo(() => {
    let totalWidth = 0;
    headwalls.map((wall) => {
      totalWidth += Number(wall.width);
      return totalWidth;
    });
    return { ft: totalWidth, in: 0 };
  }, [headwalls]);

  useEffect(() => {
    //to adjust scale for axiom
    // Select all elements with the class 'scale'
    if (ruler) {
      const firstElements = document.querySelector(".first");
      const nextElements = document.querySelectorAll(".next");

      // Update styles for 'first' elements
      firstElements.style.maxWidth = "214.285714285px";

      nextElements.forEach((element) => {
        element.style.maxWidth = "214.285714285px";
      });
      // Cleanup function to revert styles when component unmounts
      return () => {
        firstElements.style.maxWidth = "";
        nextElements.forEach((element) => {
          element.style.maxWidth = "";
        });
      };
    }
  }, [ruler, rulerWidth]);

  const handleKeyDown = (e) => {
    switch (e.key) {
      case "ArrowUp":
        view_only && clickArrowUp(customEvent, serv, railInd, rowInd, "array");
        break;
      case "ArrowDown":
        view_only &&
          clickArrowDown(customEvent, serv, railInd, rowInd, "array");
        break;
      case "ArrowLeft":
        view_only &&
          clickArrowLeft(customEvent, serv, railInd, rowInd, "array");
        break;
      case "ArrowRight":
        view_only &&
          clickArrowRight(customEvent, serv, railInd, rowInd, "array");
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    let isDragging = false;

    const handleClickOutside = (e) => {
      const clickedInsideFlexItemsEnd = e.target.closest(
        ".flex.items-end".split(" ").join(".")
      );
      if (
        !isDragging &&
        wrapperRef.current &&
        !wrapperRef.current.contains(e.target) &&
        clickedInsideFlexItemsEnd == null
      ) {
        setService("", false);
      }
    };

    const handleDragStart = () => (isDragging = true);
    const handleDragEnd = () => (isDragging = false);

    window.addEventListener("keydown", handleKeyDown);
    document.addEventListener("mousedown", handleClickOutside); // fixed
    document.addEventListener("dragstart", handleDragStart);
    document.addEventListener("dragend", handleDragEnd);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("mousedown", handleClickOutside); // match above
      document.removeEventListener("dragstart", handleDragStart);
      document.removeEventListener("dragend", handleDragEnd);
    };
  }, [serv, view_only, railInd, rowInd]);

  // useEffect(() => {
  //   let isDragging = false;

  //   window.addEventListener("keydown", handleKeyDown);
  //   const handleClickOutside = (e) => {
  //     if (
  //       !isDragging &&
  //       wrapperRef.current &&
  //       !wrapperRef.current.contains(e.target)
  //     ) {
  //       setService("", false);
  //     }
  //   };
  //   document.addEventListener("mouseup", handleClickOutside);
  //   document.addEventListener("dragstart", () => {
  //     isDragging = true;
  //   });

  //   document.addEventListener("dragend", () => {
  //     isDragging = false;
  //   });
  //   return () => {
  //     window.removeEventListener("keydown", handleKeyDown);
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, [serv, view_only, railInd, rowInd]);

  // const rulerSectionWidth = useMemo(() => {
  //   //Added 12 px more to manage border and 2px for each compartment to manage gap
  //   // return Math.round((rulerWidth.ft * 12) / 0.056 + 11);
  //   const baseWidth = (rulerWidth.ft * 12) / 0.056;
  //   const numberOfSections = headwalls.length;

  //   // Added 6 px more to manage border
  //   let additionalWidth = 6;
  //   if (numberOfSections === 2) additionalWidth += 12;
  //   else if (numberOfSections === 3) additionalWidth = 18;
  //   else if (numberOfSections === 4) additionalWidth = 24;
  //   else if (numberOfSections === 5) additionalWidth = 30;
  //   return baseWidth + additionalWidth;
  //   return baseWidth
  // }, [rulerWidth, headwalls.length]);

  const wallHeight = useMemo(() => {
    return Math.round(
      (ceiling_height.ft * 12 + ceiling_height.in) / pixelPerInch
    );
  }, [ceiling_height]);

  const ArrayHeight = useMemo(() => {
    return (ceiling_height.ft * 12 + ceiling_height.in - 6) / pixelPerInch; //6inc from bottom
  }, [ceiling_height]);

  const sectionWidth = (width) => {
    return (Number(width) * 12) / pixelPerInch;
  };

  const serviceWidth = (ser) => {
    return Math.round(ser.gang_width / pixelPerInch);
  };

  const Section1Height = useMemo(() => {
    // return (ceiling_height.ft * 12 + ceiling_height.in - 66) / 0.056; //subtracting 66inch for the rest two sections
    return (ceiling_height.ft * 12 + ceiling_height.in - 66.94) / pixelPerInch; //subtracting 66.19inch for the rest two sections+0.75 for borders
  }, [ceiling_height]);

  const row1Height = useMemo(() => {
    return Section1Height - 35.7142857143 - 51.3392857143;
    // return Section1Height ;
  }, [Section1Height]);

  const accessorieRailMargins = useMemo(() => {
    if (service?.service?.type === "surface_mounted")
      return "surfacemounted_rail_margins";
    else if (service?.service?.type === "embedded")
      return "embedded_rail_margins";
    else return "";
  }, [service?.service?.type]);

  const railBackgroundColor = useMemo(() => {
    if (
      service?.service?.type === "surface_mounted" ||
      service?.service?.type === "embedded"
    )
      return "bg-green-100";
    else return "";
  }, [service?.service?.type]);

  const accessoriePosition = (acc) => {
    const xPosition = acc.positions?.x;
    if (!xPosition || acc.mount_type !== "track") return xPosition;
    // 1. Adjustment for "Single (3 hook)"
    if (acc.name === "Single (3 hook)") {
      return xPosition - 20;
    }
    if (acc.name === "Dual (6 hook)") {
      return xPosition - 22;
    }
    if (acc.name === "Ambu Bag Holder") {
      return xPosition + 8;
    }
    if (acc.name === "Single") {
      return xPosition -6;
    }

    // 3. Default fallback for track-mounted accessories
    return xPosition;
  };

  return (
    <Wrapper
      ruler={ruler}
      width={wallWidth}
      wallHeight={wallHeight}
      ceiling_height={ceiling_height}
      model={model}
      ref={ref}
    >
      <div className="flex items-end pb-[24px] relative compass-board">
        {/* gap-[2px]  */}
        {Object.keys(accessory_rails)?.map((railKey, i) => {
          const railData = accessory_rails[railKey] || [];
          return (
            <>
              {railData?.map((ser, i) => {
                return (
                  <div
                    draggable
                    key={i}
                    className="absolute flex justify-center z-10"
                    style={{
                      left: ser.positions?.x,
                      top: ser.positions?.y,
                      cursor: "grab",
                    }}
                    onDragStart={(e) => handleDragStart(ser, e)}
                    onDragEnter={(e) => handleDragEnter(e)}
                    onDrop={(e) => handleDrop(e, "rail")}
                    onDragOver={(e) => handleonDragOver(e, "rail")}
                  >
                    {dragEntered &&
                      service?.service?.u_id !== ser?.u_id &&
                      service?.service?.is_accessory_rail &&
                      service?.service?.type !== "unimount" &&
                      ser.type !== "unimount" &&
                      ser.mount_type !== "direct" && (
                        <div
                          className="h-[234.815714286px] top-[-107.142857143px] w-full absolute"
                          style={{ background: "rgb(215 176 162)", zIndex: 0 }}
                        />
                      )}
                    <div
                      draggable={"false"}
                      style={{
                        width: ser.width / pixelPerInch,
                        backgroundImage: `url(${ser.image_url})`,
                        backgroundSize:
                          ser.type === "unimount"
                            ? "contain"
                            : ser.width < 15
                            ? "cover"
                            : "contain",
                        backgroundPosition: "center",
                        pointerEvents: "none",
                        height: ser.height / pixelPerInch,
                        zIndex: 1,
                      }}
                      onDragEnter={(e) => e.stopPropagation()}
                    />
                  </div>
                );
              })}
            </>
          );
        })}
        {/* maping accessories */}
        {Object.keys(accessory_rails)?.map((railKey, i) => {
          const railData = accessory_rails[railKey] || [];
          return (
            <>
              {railData?.map((ser, i) => (
                <>
                  {ser.accessories?.map((acc, i) => (
                    <div
                      draggable
                      key={i}
                      className="absolute flex justify-center z-10"
                      style={{
                        left: accessoriePosition(acc),
                        top: acc.positions?.y,
                        cursor: "grab",
                      }}
                      onDragStart={(e) => handleDragStart(acc, e, 1)} //sending 1 to manage that accessory rail is dragged from compass board
                      onDragEnter={(e) => handleDragEnter(e)}
                      onDrop={(e) => handleDrop(e, "rail")}
                      onDragOver={(e) => handleonDragOver(e, "rail")}
                    >
                      <div
                        draggable={"false"}
                        style={{
                          width: calculateWidth(acc),
                          backgroundImage: `url(${acc.image})`,
                          backgroundSize: "contain",
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "center",
                          pointerEvents: "none",
                          height: calculateHeight(acc),
                        }}
                        onDragEnter={(e) => e.stopPropagation()}
                      />
                    </div>
                  ))}
                </>
              ))}
            </>
          );
        })}
        {/* maping direct
         */}
        {accessory_rails["direct"]?.map((acc, i) => (
          <div
            draggable
            key={i}
            className="absolute flex justify-center z-10"
            style={{
              left: acc.positions?.x,
              top: acc.positions?.y,
              cursor: "grab",
            }}
            onDragStart={(e) => handleDragStart(acc, e, 1)} //sending 1 to manage that accessory rail is dragged from compass board
            onDragEnter={(e) => handleDragEnter(e)}
            onDrop={(e) => handleDrop(e, "rail")}
            onDragOver={(e) => handleonDragOver(e, "rail")}
          >
            <div
              draggable={"false"}
              style={{
                width: acc.width / pixelPerInch,
                backgroundImage: `url(${acc.image})`,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                pointerEvents: "none",
                height: acc.height / pixelPerInch,
              }}
              onDragEnter={(e) => e.stopPropagation()}
            />
          </div>
        ))}
        {headwalls.map((rail, railIndex) => {
          return (
            <div key={railIndex}>
              <div
                style={{
                  // height: ArrayHeight + 13,
                  height: ArrayHeight,
                  width: sectionWidth(rail.width),
                }}
                className="flex flex-col gap-[6.78571428571px] relative array" // gap-[6.78571428571px]
                id={`compass_section_${railIndex}`}
                onDragEnter={(e) => handleDragEnter(e, railIndex)}
                onDrop={(e) => handleDrop(e, "rail", railIndex)}
              >
                {/* slide services */}
                {rail.services
                  .filter((serv) => serv.is_slide)
                  .map((ser, serviceIndex) => (
                    <div
                      draggable
                      key={serviceIndex}
                      className={`absolute flex justify-center z-10 ${
                        dragEntered ? "non_dropable " : ""
                      }`}
                      style={{
                        left: ser.positions?.x,
                        top: ser.positions?.y,
                        cursor: "grab",
                        background:
                          ser == serv
                            ? view_only
                              ? "#75060f"
                              : "transparent"
                            : "transparent",
                      }}
                      onDragStart={(e) =>
                        handleDragStart(ser, e, railIndex, serviceIndex)
                      }
                      onDragEnter={(e) => handleDragEnter(e, railIndex)}
                      onClick={() => {
                        const rowBlock = document.getElementById(
                          `array_row_${railIndex}_${serv.rowPosition}`
                        );

                        const fakeEvent = {
                          target: rowBlock,
                          currentTarget: rowBlock,
                          stopPropagation: () => {
                            // No-op or logging for debug
                          },
                        };

                        // const rect = rowBlock.getBoundingClientRect();
                        setCustomEvent(fakeEvent);
                        setService(ser, true);
                        setRailInd(railIndex);
                        setRowInd(serv.rowPosition);
                      }}
                    >
                      <div
                        draggable={"false"}
                        style={{
                          width: serviceWidth(ser),
                          backgroundImage: `url(${alterImageUrl(
                            ser.image_url
                          )})`,
                          backgroundSize: "contain",
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "center",
                          pointerEvents: "none",
                          height: ser.height / pixelPerInch,
                        }}
                        onDragEnter={(e) => e.stopPropagation()}
                      />
                    </div>
                  ))}
                {/* section 1 */}
                <div
                  id="array-section-1"
                  className="w-full compass-section relative "
                  style={{
                    background: rail?.color,
                    height: `${Section1Height}px`,
                    backgroundImage: `url(${GRAINS[rail?.background]})`,
                  }}
                  onDragEnter={(e) => handleDragEnter(e, railIndex)}
                  onDragOver={(e) => handleonDragOver(e, "rail")}
                  onDrop={(e) => handleDrop(e, "rail", railIndex)}
                >
                  {/*----- to highlight droppable areas for accessorie rails------ */}
                  <div
                    className={`absolute ${
                      dragEntered && railBackgroundColor
                    } ${dragEntered && accessorieRailMargins} `}
                  />
                  {/* -------------------------------------------------------------
                   */}
                  {/* Row 1 */}
                  <Row
                    row={1}
                    rail={rail}
                    railIndex={railIndex}
                    dragEntered={dragEntered}
                    className={`mx-[29.01px] mb-[35.71428571428571px] mt-[51.33928571428571px]`}
                    handleonDragOver={handleonDragOver}
                    handleDrop={handleDrop}
                    handleDragEnter={handleDragEnter}
                    handleDragStart={handleDragStart}
                    service={service}
                    rowHeight={row1Height}
                    rowInd={setRowInd}
                    customEvent={setCustomEvent}
                    railInd={setRailInd}
                    wrapperRef={wrapperRef}
                  />
                </div>
                {/* section 2 */}
                <div
                  className="w-full compass-section relative"
                  style={{
                    background: rail?.color,
                    height: `${ARRAY.SECTION_2_HEIGHT}px`,
                    backgroundImage: `url(${GRAINS[rail?.background]})`,
                  }}
                  onDragEnter={(e) => handleDragEnter(e, railIndex)}
                  onDragOver={(e) => handleonDragOver(e, "rail")}
                  onDrop={(e) => handleDrop(e, "rail", railIndex)}
                >
                  {/*----- to highlight droppable areas for accessorie rails------ */}
                  <div
                    className={`absolute ${
                      dragEntered && railBackgroundColor
                    } ${dragEntered && accessorieRailMargins} `}
                  />
                  {/* ------------------------------------------------------------- */}
                  {/* Row 2 */}
                  <Row
                    row={2}
                    rail={rail}
                    railIndex={railIndex}
                    dragEntered={dragEntered}
                    className={
                      "h-[464.2857142857143px] mx-[29.01px] mb-[35.7142857143px] mt-[35.7142857143px]"
                    }
                    handleonDragOver={handleonDragOver}
                    handleDrop={handleDrop}
                    handleDragEnter={handleDragEnter}
                    handleDragStart={handleDragStart}
                    service={service}
                    rowInd={setRowInd}
                    railInd={setRailInd}
                    customEvent={setCustomEvent}
                    wrapperRef={wrapperRef}
                  />
                </div>
                {/* section 3 */}
                <div
                  className="w-full compass-section relative"
                  style={{
                    background: rail?.color,
                    height: `${ARRAY.SECTION_3_HEIGHT}px`,
                    backgroundImage: `url(${GRAINS[rail?.background]})`,
                  }}
                  onDragEnter={(e) => handleDragEnter(e, railIndex)}
                  onDragOver={(e) => handleonDragOver(e, "rail")}
                  onDrop={(e) => handleDrop(e, "rail", railIndex)}
                >
                  {/*----- to highlight droppable areas for accessorie rails------ */}
                  <div
                    className={`absolute ${
                      dragEntered && railBackgroundColor
                    } ${dragEntered && accessorieRailMargins} `}
                  />
                  {/* ------------------------------------------------------------- */}
                  {/* Row 3 */}
                  <Row
                    row={3}
                    rail={rail}
                    railIndex={railIndex}
                    dragEntered={dragEntered}
                    className={
                      "h-[448.6607142857143px]  mx-[29.01px] mb-[51.3392857143px] mt-[35.7142857143px]"
                    }
                    handleonDragOver={handleonDragOver}
                    handleDrop={handleDrop}
                    handleDragEnter={handleDragEnter}
                    handleDragStart={handleDragStart}
                    service={service}
                    rowInd={setRowInd}
                    railInd={setRailInd}
                    customEvent={setCustomEvent}
                    wrapperRef={wrapperRef}
                  />
                </div>
              </div>
              <p className="flex justify-center mt-10 txtBlue font-semibold text-base">
                Section {railIndex + 1}
              </p>
            </div>
          );
        })}
      </div>
      {ruler && (
        <HorizontalRuler
          class_name={`items-center bottom-[17px] z-50`}
          width={rulerWidth}
        />
      )}
      {showBedGraphic && <HospitalBed />}
    </Wrapper>
  );
});

export default Array;

const Row = ({
  row,
  rail,
  railIndex,
  dragEntered,
  className,
  handleonDragOver,
  handleDrop,
  handleDragEnter,
  handleDragStart,
  service,
  rowHeight,
  railInd,
  rowInd,
  customEvent,
  wrapperRef,
}) => {
  const rowArray = [
    ...new Set(
      rail?.services
        .filter((serv) => !serv.is_slide && serv.rowPosition === row)
        .map((item) => item.positions.y)
    ),
  ];

  const { serv, view_only, setService } = useServiceStore();
  const serviceWidth = (ser) => {
    return Math.round(ser.width / pixelPerInch);
  };

  const servicePadding = (ser) => {
    if (!ser.is_slide) return `6.69642857143px  4.46428571429px`;
    else return `5px 0 5px 0`;
  };

  const railBackgroundColor = useMemo(() => {
    if (
      service?.service?.type === "surface_mounted" ||
      service?.service?.type === "embedded" ||
      service?.service?.type === "unimount" ||
      service?.service?.is_accessory
    )
      return "";
    else return "bg-green-100";
  }, [service?.service?.type, service?.service?.is_accessory]);

  return (
    <>
      {/* added array row className to get the height and widht of row */}
      <div
        // className={`relative ${className} ${dragEntered && "bg-green-100 "}`}
        className={`relative ${className} ${
          dragEntered && railBackgroundColor
        }`}
        id={`array_row_${railIndex}_${row}`}
        onDragEnter={(e) => handleDragEnter(e, railIndex, row)}
        onDragOver={(e) => handleonDragOver(e, "rail")}
        onDrop={(e) => handleDrop(e, "rail", railIndex, row)}
        style={{ height: rowHeight }}
      >
        {rowArray.map((r, i) => (
          <div
            draggable={false}
            key={i}
            className={`w-full h-[107px] absolute  ${
              dragEntered &&
              !service?.service?.is_accessory &&
              !service?.service?.is_accessory_rail
                ? "border-dashed border-y-2 border-slate-600"
                : dragEntered && "z-10"
            }`}
            // style={{ transform: `translate(0, ${r - 6.69642857143}px)` }}
            style={{ top: ` ${r - 6.69642857143}px` }}
            onDragEnter={(e) => handleDragEnter(e, railIndex, row)}
          >
            <>
              {rail.services
                .filter((serv) => serv.rowPosition === row && !serv.is_slide)
                .filter((serv) => serv.positions.y === r)
                .map((ser, serviceIndex) => (
                  <div
                    key={serviceIndex}
                    className={`absolute flex justify-center ${
                      dragEntered ? "non_dropable " : ""
                    }`}
                    style={{
                      padding: servicePadding(ser),
                      left: `${ser.positions?.x - 4.46428571429}px`,
                      background:
                        ser == serv
                          ? view_only
                            ? "#75060f"
                            : "transparent"
                          : "transparent",
                    }}
                    onDragEnter={(e) => e.stopPropagation()}
                  >
                    <div
                      ref={wrapperRef}
                      draggable
                      className="z-10"
                      style={{
                        width: serviceWidth(ser),
                        cursor: "grab",
                      }}
                      onDragStart={(e) =>
                        handleDragStart(ser, e, railIndex, serviceIndex, row)
                      }
                      onDragEnter={(e) => e.stopPropagation()}
                      onClick={() => {
                        const rowBlock = document.getElementById(
                          `array_row_${railIndex}_${row}`
                        );

                        const fakeEvent = {
                          target: rowBlock,
                          currentTarget: rowBlock,
                          stopPropagation: () => {
                            // No-op or logging for debug
                          },
                        };
                        const rect = rowBlock.getBoundingClientRect();
                        customEvent(fakeEvent);
                        setService(ser, true);
                        railInd(railIndex);
                        rowInd(row);
                      }}
                    >
                      <div
                        draggable={"false"}
                        className="pointer-events-none"
                        style={{
                          width: serviceWidth(ser),
                          backgroundImage: `url(${alterImageUrl(
                            ser.image_url
                          )})`,
                          backgroundSize: "contain",
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "center",
                          pointerEvents: "none",
                          height: ser.height / pixelPerInch,
                        }}
                        onDragEnter={(e) => e.stopPropagation()}
                      />
                    </div>
                  </div>
                ))}
            </>
          </div>
        ))}
      </div>
    </>
  );
};
